export * from "./error-locale";
